import CarouselCollections from './carousel-collections';

export default CarouselCollections;
